/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import parse from "html-react-parser";

import '../../css/event220916_2.css';
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import { isMobile } from "react-device-detect";
//import $ from 'jquery';
// import ReactPlayer from "react-player";
// import Slider from "react-slick";

// import Timer from "react-timer-wrapper";
// import Timecode from "react-timecode";

// import ItemBox from "../../components/aketo/ItemBox";

// import { now } from "lodash";

class Event2023_agf extends Component {
  state = {
    tabIndex: 0,
  };

  componentDidMount = () => {};
  changeTab = (tab) => {
    //if(tab === 0) {
    this.setState({
      tabIndex: tab,
    });
    //} else {
    //alert('준비중입니다.')
    // }
  };
  render() {
    const { tabIndex } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="event_head">
          <h3>AGF2023</h3>
          <button type="button" className="btnClose">
            <img src={imgUrl + '/img/detail_img/close_1.png'} alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220916_2" style={{ color: '#fff' }}>
            <img src={imgUrl + '/img/event/event2023_agf/TOP.png'} />
          </div>
          <div>
            <span
              onClick={() => this.changeTab(0)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 0
                    ? imgUrl + '/img/event/event2023_agf/01_GOODS.png'
                    : imgUrl + '/img/event/event2023_agf/01_GOODS-OFF.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
            <span
              onClick={() => this.changeTab(1)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 1
                    ? '/img/event/event2023_agf/02_CAFE.png'
                    : '/img/event/event2023_agf/02_CAFE-OFF.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
            <span
              onClick={() => this.changeTab(2)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 2
                    ? imgUrl + '/img/event/event2023_agf/03_PACKAGE.png'
                    : imgUrl + '/img/event/event2023_agf/03_PACKAGE-OFF.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
          </div>

          {tabIndex === 0 ? (
            <Fragment>
              <div name="00_MD">
                <img
                  src={imgUrl + '/img/event/event2023_agf/GOOD_TOP.png'}
                  useMap="#FPMap0"
                />
              </div>
              <div>
                <a name="01_MD"></a>
                <img
                  src={imgUrl + '/img/event/event2023_agf/01_GOOD_HOLO.png'}
                />
              </div>
              <div>
                <a name="02_MD"></a>
                <img
                  src={imgUrl + '/img/event/event2023_agf/02_GOOD_STEL.png'}
                />
              </div>
              <div>
                <a name="03_MD"></a>
                <img src={imgUrl + '/img/event/event2023_agf/03_BLUE.png'} />
              </div>

              <map name="FPMap0">
                <area href="#01_MD" shape="rect" coords="122,227,601,430" />
                <area href="#02_MD" shape="rect" coords="609,232,1088,427" />
                <area href="#03_MD" shape="rect" coords="1096,234,1576,421" />
              </map>
            </Fragment>
          ) : tabIndex === 1 ? (
            <Fragment>
              <div name="00_CAFE">
                <img
                  src={imgUrl + '/img/event/event2023_agf/CAFE_TOP.png'}
                  useMap="#FPMap1"
                />
              </div>
              <div>
                <a name="01_CAFE"></a>
                <img
                  src={imgUrl + '/img/event/event2023_agf/01_CAFE_CHI.png'}
                />
              </div>
              <div>
                <a name="02_CAFE"></a>
                <img
                  src={imgUrl + '/img/event/event2023_agf/02_CAFE_HOLO.png'}
                />
              </div>
              <div>
                <a name="03_CAFE"></a>
                <img
                  src={imgUrl + '/img/event/event2023_agf/03_CAFE_ANING.png'}
                />
              </div>

              <map name="FPMap1">
                <area href="#01_CAFE" shape="rect" coords="120,226,598,422" />
                <area href="#02_CAFE" shape="rect" coords="610,234,1085,428" />
                <area href="#03_CAFE" shape="rect" coords="1097,234,1577,424" />
              </map>
            </Fragment>
          ) : (
            <Fragment>
              <div name="00_FAN_MEET">
                <img
                  src={imgUrl + '/img/event/event2023_agf/PACKAGE_TOP.png'}
                  useMap="#FPMap2"
                />
              </div>
              <div>
                <a name="01_FAN_MEET"></a>
                <img
                  src={imgUrl + '/img/event/event2023_agf/01_PACKAGE_CHI.png'}
                />
              </div>
              <div>
                <a name="02_FAN_MEET"></a>
                <img
                  src={imgUrl + '/img/event/event2023_agf/02_PACKAGE_HOLO.png'}
                />
              </div>
              <div>
                <a name="03_FAN_MEET"></a>
                <img
                  src={imgUrl + '/img/event/event2023_agf/03_PACKAGE_ANING.png'}
                />
              </div>
              <map name="FPMap2">
                <area
                  href="#01_FAN_MEET"
                  shape="rect"
                  coords="121,229,600,422"
                />
                <area
                  href="#02_FAN_MEET"
                  shape="rect"
                  coords="612,231,1088,428"
                />
                <area
                  href="#03_FAN_MEET"
                  shape="rect"
                  coords="1094,231,1573,422"
                />
              </map>
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event2023_agf));
